import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "api/axiosInstance";
import { notify } from "../utils/notificationUtils";
import { toLocalDateString } from "utils/common";

export const listOrders = createAsyncThunk(
    "orders/list",
    async (filters = '', thunkAPI) => {
        try {
            const queryString = Object.keys(filters).map((key) => `${key}=${filters[key]}`).join("&");

            const { data } = await api.get(`/orders?${queryString}`);

            return thunkAPI.fulfillWithValue(data);
        } catch (err) {
            const message = err.response?.data?.error || err.message;
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const createOrder = createAsyncThunk(
    "orders/create",
    async (data, thunkAPI) => {
        try {
            const { data: response } = await api.post("/orders", data);
            return thunkAPI.fulfillWithValue(response);
        } catch (err) {
            const message = err.response?.data?.error || err.message;
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const updateOrder = createAsyncThunk(
    "orders/update",
    async (data, thunkAPI) => {
        try {
            const { data: response } = await api.put(`/orders/${data.id}`, data);
            return thunkAPI.fulfillWithValue(response);
        } catch (err) {
            const message = err.response?.data?.error || err.message;
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const cancelOrder = createAsyncThunk(
    "orders/cancel",
    async (id, thunkAPI) => {
        try {
            const { data: response } = await api.put(`/orders/${id}/cancel`);
            return thunkAPI.fulfillWithValue(response);
        } catch (err) {
            const message = err.response?.data?.error || err.message;
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const paymentOrder = createAsyncThunk(
    "orders/payment",
    async (data, thunkAPI) => {
        try {
            const { data: response } = await api.put(`/orders/${data.id}/payment`, data);
            return thunkAPI.fulfillWithValue(response);
        } catch (err) {
            const message = err.response?.data?.error || err.message;
            return thunkAPI.rejectWithValue(message);
        }
    }
);

const ordersSlice = createSlice({
    name: "orders",
    initialState: {
        orders: [],
        selectedOrder: null,
        orderTypes: [{ value: 'sale', label: 'Venta' }, { value: 'service', label: 'Servicio' }, { value: 'mixed', label: 'Mixto' }],
        orderStatus: [{ value: 'draft', label: 'Borrador' }, { value: 'open', label: 'Abierta' }, { value: 'confirmed', label: 'Confirmada' }, { value: 'closed', label: 'Cerrada' }, { value: 'canceled', label: 'Cancelada' }],
        orderPaymentMethods: [{ value: 'cash', label: 'Efectivo' }, { value: 'card', label: 'Tarjeta' }, { value: 'transfer', label: 'Transferencia' }],
    },
    reducers: {
        setSelectedOrder: (state, action) => {
            state.selectedOrder = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(listOrders.fulfilled, (state, action) => {
                state.orders = action.payload.map(order => {
                    order.customer_name = order.customer.name
                    order.order_type_name = state.orderTypes.find(obj => obj.value == order.order_type)?.label
                    order.status_name = state.orderStatus.find(obj => obj.value == order.status)?.label
                    order.order_date = toLocalDateString(order.created_at)

                    return order
                });
            })
            .addCase(createOrder.fulfilled, (state, action) => {
                notify('Orden creada exitosamente', 'success')
                action.payload.customer_name = action.payload.customer.name
                action.payload.order_type_name = state.orderTypes.find(obj => obj.value == action.payload.order_type)?.label
                action.payload.status_name = state.orderStatus.find(obj => obj.value == action.payload.status)?.label
                action.payload.order_date = toLocalDateString(action.payload.created_at)
                state.orders = [...state.orders, action.payload];
            })
            .addCase(updateOrder.fulfilled, (state, action) => {
                notify('Orden actualizada exitosamente', 'success')
                action.payload.customer_name = action.payload.customer.name
                action.payload.order_type_name = state.orderTypes.find(obj => obj.value == action.payload.order_type)?.label
                action.payload.status_name = state.orderStatus.find(obj => obj.value == action.payload.status)?.label
                action.payload.order_date = toLocalDateString(action.payload.created_at)
                state.orders = state.orders.map(order => order.id === action.payload.id ? action.payload : order);
            })
            .addCase(cancelOrder.fulfilled, (state, action) => {
                notify('Orden cancelada exitosamente', 'success')
                state.orders = state.orders.filter(order => order.id !== action.payload.id);
            })
            .addCase(paymentOrder.fulfilled, (state, action) => {
                notify('Orden pagada exitosamente', 'success')
                state.orders = state.orders.map(order => order.id === action.payload.id ? action.payload : order);
            })
    }
});

export const {
    setSelectedOrder
} = ordersSlice.actions;

export default ordersSlice.reducer;
